import classnames from 'classnames'
import { stepSelected } from 'common/actions'
import { css } from 'emotion'
import { CreditCardStep, LoanStep, Product } from 'even-ts-static'
import * as React from 'react'
import { connect } from 'react-redux'
import { Offer } from 'ui/multi-product/constants/models'
import { getContrastingColor } from 'ui/multi-product/utils'
import ThemeConsumer from '../ThemeConsumer'

const styles = require('./styles')
const resultsStyles = require('embed/styles/results')

interface OwnProps {
  offers: Offer[]
  product: Product
}

interface DispatchProps {
  dispatchApplicationStepSelected: (product: Product) => void
}

type Props = OwnProps & DispatchProps

const NoPreviewOffersMessageComponent: React.FC<Props> = ({ offers, product, dispatchApplicationStepSelected }) => {
  const dispatchApplicationStep = React.useCallback(() => dispatchApplicationStepSelected(product), [product])

  return offers.length === 0 ? (
    <ThemeConsumer>
      {({ borderRadiusSmall, ctaStyles, colorTextPrimary }) => (
        <div className={styles.emptyResultsContainer}>
          <h2 className={resultsStyles.emptyResults}>The right offers are a few steps away</h2>
          <p>It looks like we need a little more information from you in order to find you the best offers.</p>
          <button
            className={classnames(
              resultsStyles.button,
              css(`
            color: ${getContrastingColor(ctaStyles?.backgroundColor, { black: colorTextPrimary })};
            border-radius: ${borderRadiusSmall};
            &:hover {opacity: 0.84;}
          `),
            )}
            style={ctaStyles}
            onClick={dispatchApplicationStep}
          >
            Get Started
          </button>
        </div>
      )}
    </ThemeConsumer>
  ) : null
}

const mapDispatchToProps = (dispatch): DispatchProps => ({
  dispatchApplicationStepSelected: (product: Product) => {
    switch (product) {
      case Product.Loan:
        dispatch(stepSelected(product, LoanStep.Application))
        break
      case Product.CreditCard:
        dispatch(stepSelected(product, CreditCardStep.Intro))
        break
      default:
        break
    }
  },
})

export const NoPreviewOffersMessage = connect(null, mapDispatchToProps)(NoPreviewOffersMessageComponent)
